import { useTranslation } from "react-i18next";
import { unreadEmailTagLabel } from "./unreadInboundMail";
import "./unreadInboundMail.css";

export function UnreadEmailTagBadge({ tag, className = "" }) {
  const { t } = useTranslation();
  const label = unreadEmailTagLabel(tag, t) || t("case.unread_mail.tag");
  return (
    <span className={`pm-unread-mail-badge is-pulse ${className}`.trim()} title={label}>
      {label}
    </span>
  );
}
